// Clone-safe representation of errors crossing a worker boundary.
export const RELAY_ERROR_MARKER = '__powersyncError';
const MAX_CAUSE_DEPTH = 5;
function isErrorLike(value) {
    return (typeof value === 'object' &&
        value !== null &&
        typeof value.name === 'string' &&
        typeof value.message === 'string');
}
function missing(reason) {
    return {
        [RELAY_ERROR_MARKER]: true,
        name: 'PowerSyncMissingRejectionReason',
        message: `No rejection reason was provided (${reason}).`,
        state: 'missing'
    };
}
function serializeCause(value, depth, ctx) {
    if (isErrorLike(value)) {
        if (depth <= 0) {
            ctx.lossy = true;
            return '[Max depth reached]';
        }
        return serialize(value, depth, ctx);
    }
    if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    ctx.lossy = true;
    return `[Unserializable ${typeof value}]`;
}
function serialize(value, depth, ctx) {
    if (isSerializedRelayError(value))
        return value;
    if (!isErrorLike(value))
        return serializePlain(value);
    const source = value;
    const result = {
        [RELAY_ERROR_MARKER]: true,
        name: source.name || 'Error',
        message: source.message,
        state: 'serialized'
    };
    const stack = source.stack;
    if (typeof stack === 'string')
        result.stack = stack;
    // Not standard Error fields, but wa-sqlite errors (code) and HTTP errors (status) carry them and consumers need them as context.
    if (typeof source.code === 'string' || typeof source.code === 'number')
        result.code = source.code;
    if (typeof source.status === 'number')
        result.status = source.status;
    if (source.cause !== undefined)
        result.cause = serializeCause(source.cause, depth - 1, ctx);
    if (ctx.lossy && result.state !== 'missing')
        result.state = 'partial';
    return result;
}
/** Never stringifies an arbitrary object: it may hold credentials or a request payload. */
function serializePlain(value) {
    const printable = typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
    return {
        [RELAY_ERROR_MARKER]: true,
        name: typeof value === 'string' ? 'String' : 'Error',
        message: printable ? String(value) : 'Non-Error rejection',
        state: 'serialized'
    };
}
/**
 * Serializes a caught value into a clone-safe shape. Never throws and never
 * returns `undefined` — a missing rejection reason becomes `state: 'missing'`.
 */
export function serializeErrorForRelay(value) {
    try {
        if (value === undefined || value === null)
            return missing(value);
        return serialize(value, MAX_CAUSE_DEPTH, { lossy: false });
    }
    catch {
        return {
            [RELAY_ERROR_MARKER]: true,
            name: 'Error',
            message: 'Unable to serialize rejection reason',
            state: 'partial'
        };
    }
}
export function isSerializedRelayError(value) {
    return typeof value === 'object' && value !== null && value[RELAY_ERROR_MARKER] === true;
}
//# sourceMappingURL=error-serialization.js.map